<section class="w-100" [formGroup]="form">
  <div class="dialog-header">
    <h2 class="dialog-title text-gray-900">
      {{ "APP.DISCOUNT_LABEL" | translate }}
    </h2>
    <button
      type="button"
      aria-label="Close"
      class="btn-close"
      (click)="onClose()"
    ></button>
  </div>
  <div class="dialog-content py-4">
    <div class="row py-4">
      <div class="col-12 mb-1">
        <app-input
          label="APP.DISCOUNT_SHORT_LABEL"
          [labelMode]="LabelMode.NO_LABEL"
          type="code"
          placeholder="APP.DISCOUNT_PLACEHOLDER"
          formControlName="code"
          [error]="errors()?.code"
        ></app-input>
      </div>
    </div>
  </div>
  <div class="dialog-footer flex-end gap-4">
    <button
      type="reset"
      class="btn btn-outline-light border"
      (click)="onClose()"
    >
      {{ "COMPONENT.CANCEL" | translate }}
    </button>

    <button class="btn btn-primary col-12 col-sm-auto" (click)="verifyCode()">
      {{ "APP.USE_CODE" | translate }}
    </button>
  </div>
</section>
